<template>
	<div class="h1-case-features">
		<hr >
		<section
			v-for="section in h1CaseSections"
			class="h1-case-feature"
			:class="
				Number(section.reverse_order_desktop) && 'h1-case-feature--reverse'
			"
			:key="section.id"
			:id="Number(section.sort_order) === 2 && 'external-drive'"
		>
			<div v-if="Number(section.sort_order) !== 1" class="container">
				<div class="row">
					<div class="col-md-6">
						<div class="h1-case-feature__image">
							<img :src="section.logo_url" :alt="section.title" >
						</div>
					</div>
					<div class="col-md-6">
						<h3 class="h1-case-feature__heading">
							{{ section.title | stripTags }}
						</h3>
						<div class="h1-case-feature__text" v-html="section.body" />
					</div>
				</div>
			</div>

			<div v-else class="container" ref="h1VideoContainer">
				<div class="row">
					<div class="col-md-6">
						<div class="h1-case-feature__video">
							<youtube-video
								video-id="oBkFAbuuT_8"
								:autoplay="true"
								:autoplay-offset="300"
							/>
						</div>
					</div>
					<div class="col-md-6">
						<h3 class="h1-case-feature__heading">
							{{ section.title | stripTags }}
						</h3>
						<div class="h1-case-feature__text" v-html="section.body" />
						<div class="h1-case-feature__buttons">
							<button
								disabled
								class="btn btn-soldout"
							>
								Not Available
							</button>
						</div>
					</div>
				</div>
			</div>
			<hr >
		</section>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { landingPagesMixin } from "@u/mixins";
import YoutubeVideo from "@c/generals/youtube-video";

export default {
	name: "H1CaseFeatures",
	components: {
		YoutubeVideo
	},
	mixins: [landingPagesMixin],
	computed: {
		...mapState({
			h1CaseSections: state => {
				return state.StarterPc.pageData.landing_page_sections
					.slice(6, 12)
					.filter((section, index) => index != 1);
			},
			builds: state => state.StarterPc.pageData.landing_page_builds
		}),
		buildNumber() {
			return this.builds.length ? this.builds[0].bld_number : 0;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.h1-case-features {
	.h1-case-feature {
		text-align: right;

		@media (max-width: 768px) {
			text-align: left;
		}

		.container {
			@media (min-width: 991px) {
				height: 540px;
				display: flex;
				justify-content: center;
			}

			@media (max-width: 768px) {
				padding-top: 0;
				padding-bottom: 20px;
				padding-top: 20px;
			}
		}

		.row {
			align-items: center;

			@media (min-width: 991px) {
				width: 100%;
			}

			@media (min-width: 769px) {
				display: flex;
			}
		}

		&__heading {
			color: #444259;
			font-size: 36px;
			line-height: 43px;
			text-transform: uppercase;
			max-width: 440px;
			margin: 0 auto 15px;

			@media (max-width: 768px) {
				margin: 15px auto;
			}
		}

		&__text {
			max-width: 440px;
			margin: 0 auto;
		}

		&__image {
			max-width: 450px;
			margin: 0 auto;

			img {
				width: 100%;
			}
		}

		&__video {
			height: 300px;

			@media (min-width: 767px) and (max-width: 769px) {
				max-width: 440px;
				margin: 0 auto 30px;
			}

			video {
				width: 100%;
			}
		}

		&__buttons {
			display: flex;
			max-width: 440px;
			margin: 25px auto 0;

			@media (max-width: 768px) {
				display: block;
			}
		}

		&__button {
			width: 195px;
			border-radius: 5px;
			text-align: center;
			padding: 18px 0;
			font-size: 14px;
			text-transform: uppercase;
			transition: all 0.2s;
			display: flex;
			justify-content: center;
			align-items: center;

			@media (max-width: 768px) {
				width: 100%;
			}

			&.h1-case-feature__button--purple {
				background-color: $oldpurple;
				color: $white;
				margin-right: 15px;

				@media (max-width: 768px) {
					margin-bottom: 15px;
					margin-right: 0;
				}

				&:hover {
					color: $oldpurple;
					border: 2px solid $oldpurple;
					background-color: $white;
				}
			}

			&.h1-case-feature__button--outline {
				color: $oldpurple;
				border: 2px solid $oldpurple;

				&:hover {
					background-color: $oldpurple;
					color: $white;
				}
			}
		}

		hr {
			border-top: 1px solid #dadde0;
		}
	}

	.h1-case-feature:last-child {
		hr {
			display: none;
		}
	}

	.h1-case-feature--reverse {
		text-align: left;

		.row {
			flex-direction: row-reverse;
		}
	}

	.btn-soldout {
		background-color: rgba(#5f707f, 0.5);
		border: none;
		color: #FFF;
	}
}
</style>

<style lang="scss">
.h1-case-feature {
	&__text {
		color: #5f707f;
		font-size: 16px;
		line-height: 28px;
	}
}
</style>
